import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionAclService {

  baseUrl = environment.apiUrl

  constructor(public http: HttpClient) {
  }

  public getNavbar(): Observable<any> {
    return this.http.get<any>(this.baseUrl+'/permission/navbar', { headers: this.headers });
  }
  public has(permission:string): Observable<any> {
    return this.http.get<any>(this.baseUrl+'/permission/has/'+permission, { headers: this.headers });
  }

  public hasGroup(permission:string):Observable<any> {
    return this.http.get<any>(this.baseUrl+'/permission/has-group/'+permission, { headers: this.headers });
  }

  public getAllPermissions(): Observable<any>{
    return this.http.get<any>(this.baseUrl+'/permission/permissions-nav-left', { headers: this.headers });
  }

  public getPermission(permission:any, idProjeto:number): Observable<any>{
    return this.http.post<any>(this.baseUrl+'/permission/permissions-items/' + idProjeto, permission, { headers: this.headers });
  }

  public validateRoute(obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/permission/validate-route', obj, { headers: this.headers });
  }

  public get headers(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", 'application/json');
    return headers;
  }
}

